import {
  Hammer,
  Zap,
  Paintbrush,
  Trees,
  Laptop2,
  Truck,
  Wrench,
  ClipboardList,
} from "lucide-react";

// Format integer cents → "4,99" (NL-BE locale, no currency symbol)
export const formatEuro = (cents) => {
  const v = (cents || 0) / 100;
  return v.toFixed(2).replace(".", ",");
};

export const TYPES = [
  { id: "Renovatie & Bouw", icon: Hammer, desc: "Verbouwingen, uitbreidingen, nieuwbouw" },
  { id: "Elektriciteit & Sanitair", icon: Zap, desc: "Elektriciteit, loodgieterij, verwarming" },
  { id: "Schilderwerk & Afwerking", icon: Paintbrush, desc: "Schilderen, plafonds, vloeren" },
  { id: "Tuinaanleg & Buitenwerken", icon: Trees, desc: "Terras, oprit, omheining, beplanting" },
  { id: "IT & Technologie", icon: Laptop2, desc: "Websites, software, hardware, netwerk" },
  { id: "Verhuizing & Transport", icon: Truck, desc: "Verhuisdiensten, opslag, transport" },
  { id: "Onderhoud & Herstelling", icon: Wrench, desc: "HVAC, herstellingen, onderhoud" },
  { id: "Andere", icon: ClipboardList, desc: "Vul je type in en wij doen de rest" },
];

export const STEP_LABELS = ["Type", "Upload", "Pakket", "Gegevens", "Betaling"];

export async function fileToB64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const res = reader.result;
      const idx = String(res).indexOf(",");
      resolve(idx >= 0 ? String(res).slice(idx + 1) : String(res));
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
